module.exports = __webpack_public_path__ + "img/hsbc.d01fc8ac.svg";